export default __webpack_public_path__ + "static/pregunta-5-9849d450f83e2be100b92559a7ef9d66.png";